import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const MobileAppDevelopment = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          progress = 3000 - progress * 1.6;
    
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        window.addEventListener("scroll", handleScroll);
    
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, 
        threshold: 0.2,
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, 
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 },
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 },
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 },
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/service-solutions.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">Mobile App Development</h1>
                  <h2 id="sub_heading1">
                  In the modern digital landscape, businesses require custom mobile app development to stay competitive, enhance user experience, and streamline their operations. With the rapid rise of mobile technology, having a bespoke mobile application is no longer a luxury but a necessity. Companies that invest in business app development benefit from increased engagement, improved efficiency, and greater scalability. By choosing top mobile app development services, businesses can ensure robust, secure, and feature-rich solutions tailored to their specific needs.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="why_coustom_app">
            <div className="wrapper">
              <h3>
              What is <span>Custom Mobile App Development ?</span>
              </h3>
              <p>
              Custom mobile app development is the process of designing and creating software applications specifically tailored to a business’s unique requirements. Unlike generic off-the-shelf solutions, tailored app solutions are built from the ground up to align with business objectives, ensuring seamless integration with existing systems. Whether it’s iOS app development or Android app development, a well-crafted mobile solution enhances digital transformation and efficiency.
              </p>
              <h3>
              Why Invest in <span>Custom Mobile App Development ?</span>
              </h3>
              <p>
              Choosing a mobile application development company to create a personalized app offers numerous benefits, including:
              </p>
              <h4>1. Unmatched User Experience</h4>
              <p>A custom mobile application delivers a unique and intuitive user interface, enhancing customer interaction and satisfaction. Personalized designs and functionalities ensure that businesses provide their users with exactly what they need. Companies investing in UI/UX design services for mobile apps can create visually appealing and easy-to-use applications that drive engagement.</p>
              <h4>2. Higher Efficiency and Productivity</h4>
              <p>With enterprise mobile solutions, companies can optimize workflows, automate repetitive tasks, and increase overall productivity. Custom applications provide functionalities that are specifically tailored to improve business processes. From cross-platform app development to hybrid mobile app development, businesses can ensure seamless operations across different devices and operating systems.</p>
              <h4>3. Better Security Measures</h4>
              <p>Security is a major concern in today’s digital world. A custom app development approach ensures that businesses can integrate advanced security features to protect sensitive data, reducing vulnerabilities that are often found in pre-built applications. With secure mobile application development, businesses can implement encryption, multi-factor authentication, and data protection strategies.</p>
              <h4>4. Scalability and Future Growth</h4>
              <p>As businesses grow, so do their requirements. Mobile app development solutions are built with scalability in mind, allowing for the addition of new features and seamless expansion to accommodate increased user demand. Investing in cloud-based mobile applications ensures better storage, accessibility, and performance.</p>
              <h4>5. Competitive Edge in the Market</h4>
              <p>By offering unique functionalities, iOS and Android app development enables businesses to differentiate themselves from competitors. Custom applications are designed to offer innovative solutions that align with industry trends. With on-demand app development and eCommerce mobile app development, businesses can cater to modern consumer needs and enhance digital presence.</p>
              <h3><span>Conclusion</span></h3>
              <p>Incorporating custom mobile app development into your business strategy ensures improved engagement, optimized operations, and greater market reach. By leveraging high-performance mobile application development services, businesses can establish themselves as industry leaders.</p>
              <p>If you are ready to transform your business with a tailored app solution, get in touch with a professional mobile application development company today! Whether you need native mobile app development, wearable app development, or IoT mobile solutions, an expert team can turn your vision into reality.</p>
            </div>
          </div>
          <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
                  </div>
                <div className="let_build">
                    <div className="wrapper">
                    <h4>Let’s Build <span> Your App Together </span></h4>
                  
                  <p>
                    Whether you’re a startup looking to disrupt the market or an
                    established enterprise aiming to enhance operational efficiency,
                    CodeFlix is here to bring your vision to life. Let’s create a
                    custom mobile app that drives results and delights your users.{" "}
                    <br />
                    Contact Us today to get started on your mobile app development
                    journey.
                  </p>
                    </div>
                </div>
        </>
      );
};
export default MobileAppDevelopment;
